export const toggleFilter = <T = string>(filterId: T, selectedFilterIds: T[]): T[] => {
  return selectedFilterIds.includes(filterId)
    ? selectedFilterIds.filter((id) => id !== filterId)
    : [...selectedFilterIds, filterId]
}

export const transformFilters = (filters: Record<string, unknown[]>) => {
  if (!filters) return {}

  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      return {
        ...acc,
        [key]: value.join(','),
      }
    }
    return acc
  }, {})
}
